import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import { getLang, getPrefixLang } from '../../../app/selectors/lang'
import {
  SelectionButton,
  useDidUpdateEffect,
  usePrevious
} from '../../../../../shared'
import useActivePanel from '../../hooks/useActivePanel'
import { useUiStore } from '../../../app/hooks'
import { useActiveLocation } from '../../../location'
import { setLocalStorage } from '../../../../../shared/utils'
import useCondensedPanel from '../../hooks/useCondensedPanel'
import useHoveredPanel from '../../hooks/useHoveredPanel'

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: theme.app.panelWidth
  }
}))

/**
 * Button used for options in the full panel view
 */
const SedaPanelButton = ({
  panelId,
  primaryFormatter,
  secondaryFormatter,
  ...props
}) => {
  const classes = useStyles()
  const buttonRef = useRef(null)
  const [hintOpen, setHintOpen] = useState()
  const [activePanel, setActivePanel] = useActivePanel()
  const [activeLocation] = useActiveLocation()
  const [panelCondensed] = useCondensedPanel()
  const [panelHovered] = useHoveredPanel()
  const prevActivePanel = usePrevious(activePanel)
  const showPanelHints = useUiStore(store => store.showPanelHints)
  const setShowPanelHint = useUiStore(store => store.setShowPanelHint)

  useEffect(() => {
    if(['metric'].includes(panelId) && showPanelHints[panelId] && !activePanel && panelCondensed && !panelHovered && !activeLocation) {
      setTimeout(() =>
        setHintOpen(true)
      , 400)
    } else {
      setHintOpen(false)
    }
  }, [panelId, showPanelHints, activePanel, activeLocation, panelCondensed, panelHovered])

  // Restore focus to appropriate element on panel close
  useDidUpdateEffect(() => {
    if (
      !activePanel &&
      prevActivePanel === panelId &&
      buttonRef.current
    ) {
      buttonRef.current.querySelector("[role='button']").focus()
    }
  }, [activePanel, prevActivePanel, panelId, buttonRef.current])

  const handleHintClose = (e) => {
    setShowPanelHint(panelId, false)
		setLocalStorage('disable-hint-metric', true)
    e?.preventDefault()
  }
  
  return (
    <SelectionButton
      ref={buttonRef}
      className={classes.root}
      active={activePanel === panelId}
      primary={primaryFormatter(panelId)}
      secondary={secondaryFormatter(panelId)}
      // HintTooltipProps={{
      //   title: getLang(`PANEL_HINT_${panelId}_TITLE`),
      //   body: getLang(`PANEL_HINT_${panelId}_BODY`),
      //   open: hintOpen,
      //   onClose: handleHintClose
      // }}
      onClick={(e) => {
        if(e.target.closest('[role="tooltip"]')) return
        setActivePanel(panelId)
        handleHintClose()
      }}
      {...props}
    />
  )
}

SedaPanelButton.defaultProps = {
  primaryFormatter: selectionId =>
    getPrefixLang(selectionId, 'PANEL_TITLE'),
  secondaryFormatter: selectionId =>
    getPrefixLang(selectionId, 'LABEL')
}

SedaPanelButton.propTypes = {
  /** identifier for what type of selection the button is for */
  selectionId: PropTypes.string,
  primaryFormatter: PropTypes.func,
  /** current value of the selection */
  value: PropTypes.string
}

export default SedaPanelButton
